import { render } from "./HeaderPayment.vue?vue&type=template&id=46aaf312&ts=true"
import script from "./HeaderPayment.vue?vue&type=script&lang=ts"
export * from "./HeaderPayment.vue?vue&type=script&lang=ts"

import "./HeaderPayment.vue?vue&type=style&index=0&id=46aaf312&lang=css"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
